// Get webroot for relative URL construction
export const getWebroot = (): string => {
  // Use environment variable if available (set at build time)
  const envWebroot = process.env.REACT_APP_WEBROOT;
  if (envWebroot) {
    return envWebroot.startsWith('/') ? envWebroot : `/${envWebroot}`;
  }
  
  // For relative URLs, we can detect from browser location
  // This is much simpler than the previous approach
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;
    
    // If path starts with known webroot patterns, extract it
    const match = pathname.match(/^\/([^/]+)/);
    if (match) {
      const firstSegment = match[1].toLowerCase();
      const webrootPatterns = ['samler', 'comics', 'app', 'collection', 'manga', 'books'];
      
      if (webrootPatterns.includes(firstSegment)) {
        return `/${match[1]}`;
      }
    }
  }
  
  // Default to empty string (root deployment)
  return '';
};